var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1842 0C23.0158 0 24.5 1.41 24.5 3.15V14.85C24.5 16.59 23.0158 18 21.1842 18H3.81579C2.93639 18 2.093 17.6681 1.47117 17.0774C0.849341 16.4866 0.5 15.6854 0.5 14.85V3.15C0.5 1.41 1.98421 0 3.81579 0H21.1842ZM22.9211 5.6106L12.8802 10.857C12.7769 10.911 12.6622 10.9423 12.5445 10.9486C12.4268 10.9549 12.3091 10.9361 12.2 10.8936L12.1198 10.8576L2.07895 5.61V14.85C2.07895 15.2876 2.26194 15.7073 2.58766 16.0167C2.91338 16.3262 3.35515 16.5 3.81579 16.5H21.1842C21.6448 16.5 22.0866 16.3262 22.4123 16.0167C22.7381 15.7073 22.9211 15.2876 22.9211 14.85V5.6106ZM21.1842 1.5H3.81579C3.35515 1.5 2.91338 1.67384 2.58766 1.98327C2.26194 2.29271 2.07895 2.71239 2.07895 3.15V3.8994L12.5 9.3438L22.9211 3.8988V3.15C22.9211 2.71239 22.7381 2.29271 22.4123 1.98327C22.0866 1.67384 21.6448 1.5 21.1842 1.5Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mailOutline.a86cae71986704a9af295e1b4b556df0.svg";
export { ForwardRef as ReactComponent };